export default "__VITE_ASSET__D0mfq5m4__"